module.exports = __webpack_public_path__ + "static/img/home_bg_zongheti.9b6d247.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_bg_zongheti.png
// module id = fsFq
// module chunks = 1